<tt-page *ngIf="page">
    <tt-page-heading *ngIf="page.webpage_heading" [ttModel]="page.webpage_heading"></tt-page-heading>
    <tt-radio-button-group [ttModel]="yearSelector" (ttModelChange)="selectYear($event)" [ttDisabled]="loading || saving">
        <tt-radio-button ttValue="prev" ttLabel="prev_year"></tt-radio-button>
        <tt-radio-button ttValue="this" ttLabel="this_year"></tt-radio-button>
        <tt-radio-button ttValue="next" ttLabel="next_year"></tt-radio-button>
    </tt-radio-button-group>
    <tt-radio-button-group [ttModel]="selectedView" (ttModelChange)="selectView($event)" [ttDisabled]="loading || saving">
        <tt-radio-button ttValue="CALENDAR" ttLabel="bg_shiftview_main_calendar"></tt-radio-button>
        <tt-radio-button ttValue="GRAPH" ttLabel="bg_shiftview_main_graph"></tt-radio-button>
        <tt-radio-button ttValue="GRID" ttLabel="bg_shiftview_main_grid"></tt-radio-button>
    </tt-radio-button-group>
    <tt-radio-button-group *ngIf="selectedView === 'GRAPH'" [ttModel]="timePeriod" (ttModelChange)="selectTimePeriod($event)" [ttDisabled]="loading || saving">
        <tt-radio-button ttValue="WEEK" ttLabel="bg_timeperiod_week"></tt-radio-button>
        <tt-radio-button ttValue="MONTH" ttLabel="bg_timeperiod_month"></tt-radio-button>
    </tt-radio-button-group>
    <div [hidden]="selectedView !== 'CALENDAR'">
        <div class="shift-calendar">
            <div *ngFor="let month of calendar.months | keyvalue: numericKeyOrder" class="shift-calendar-month">
                <table>
                    <thead>
                        <tr><th colspan="8"><button type="button" (click)="monthClick(month.key)">{{ calendar.monthnames[month.key] }}</button></th></tr>
                        <tr><th></th><th *ngFor="let letter of calendar.dayletters | keyvalue: numericKeyOrder"><button type="button" (click)="dayClick(letter.key, month.key)">{{ letter.value }}</button></th></tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let week of month.value | keyvalue: weekOrder">
                            <th><button type="button" (click)="weekClick(week.key)">{{ week.key }}</button></th>
                            <td *ngFor="let day of week.value | keyvalue: numericKeyOrder" [attr.style]="'color:' + day.value.text_color_hex + ';background:' + day.value.background_color_hex + ';' + (day.value.style || '')" [title]="day.value.remark">
                                <button type="button" [disabled]="!day.value.systemdate || +day.value.is_protected !== 0 || loading || saving" (click)="tableCellClick(day.value.systemdate)">{{ day.value.day_no }}</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div *ngFor="let shift of shifts; let index = index" class="shift-choice" [class.shift-choice-selected]="selectedShift === shift">
            <button type="button" [style.background-color]="shift.background_color_hex" [style.color]="shift.text_color_hex" (click)="setShiftSelected(index)">{{ shift.item_name }} ({{ shift.shiftDays }} / {{ totalShiftDays }})</button>
        </div>
        <tt-button-save ttText="save" [ttLoading]="saving || loading" (ttClick)="saveChanges()"></tt-button-save>
    </div>
    <div [hidden]="selectedView !== 'GRID'"><tt-grid *ngIf="grid" [(ttOptions)]="grid"></tt-grid></div>
    <ag-charts-angular *ngIf="selectedView === 'GRAPH' && graph" [options]="graph"></ag-charts-angular>
</tt-page>
